import { EvaluationSectionItemType } from 'generated/graphql';
import { useTranslation } from 'react-i18next';

/**
 * Maps an EvaluationSectionItemType enum key to its corresponding label.
 * The label is translated using i18n
 * @param key - The EvaluationSectionItemType enum key.
 * @returns The label corresponding to the given enum key or undefined.
 */
export const ItemTypeLabelMapper = (key: EvaluationSectionItemType): string | undefined => {
	const { t } = useTranslation('', { keyPrefix: 'common.settings.evaluationForms' });

	const enumToLabelMap: { [key in EvaluationSectionItemType]: string | undefined } = {
		[EvaluationSectionItemType.Competency]: t('competency.title'),
		[EvaluationSectionItemType.FinalScore]: t('finalScore.title'),
		[EvaluationSectionItemType.MultipleChoice]: t('multipleChoice.title'),
		[EvaluationSectionItemType.OpenQuestion]: t('openQuestion.title'),
		[EvaluationSectionItemType.Paragraph]: undefined,
		[EvaluationSectionItemType.ReviewGoals]: t('reviewGoals.title'),
		[EvaluationSectionItemType.Sentiment]: t('sentiment.title'),
		[EvaluationSectionItemType.Signature]: t('signature.title'),
		[EvaluationSectionItemType.Stars]: t('stars.title'),
		[EvaluationSectionItemType.DevelopmentPlan]: t('developmentPlan.title'),
		[EvaluationSectionItemType.Title]: undefined,
	};

	return enumToLabelMap[key]?.toLowerCase();
};
